import React from "react";
import { useTranslation } from 'react-i18next';
import CONST from "../../config/CONST";
import {useDispatch, useSelector} from "react-redux";
import {getAppData, setIsFormLayerVisible} from "../../store/slices/appSlice";
import GATracker, {GAEventBuildObject} from "../../helpers/GATracker";
import {getFinancialConfiguration} from "../../store/slices/financialConfigurationsSlice";


const FormLayerCloseCta = () => {

    const dispatch = useDispatch();

    const { t } = useTranslation();

    const appData = useSelector(getAppData);
    const financialConfiguration = useSelector(getFinancialConfiguration);

    const onClick = () => {
        dispatch(setIsFormLayerVisible(false));

        GATracker.trackEvent(GAEventBuildObject({
            event: {
                name: GATracker.EVENTS.LEAD_FORM_CLOSE.name,
                category: GATracker.EVENTS.LEAD_FORM_CLOSE.category,
                action: GATracker.EVENTS.LEAD_FORM_CLOSE.action
            },
            appData: appData,
            financialConfiguration: financialConfiguration
        }));
    }

    if(!appData || !financialConfiguration) {
        return null;
    }

    return (
            <div className={`${CONST.CSS_NAMESPACE}FormLayerCloseCta`}>
                <button
                    title={t('FormLayerHeader.CTA.Back')}
                    onClick={onClick}
                >
                    <svg width="50" height="50" viewBox="0 0 50 50" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <rect x="1" y="1" width="48" height="48" rx="24" stroke="black" strokeWidth="2"/>
                        <path d="M29.7534 38.6103C29.1211 38.6103 28.4901 38.3695 28.0072 37.8866L15.1206 25L28.0072 12.1134C28.9717 11.1489 30.5351 11.1489 31.4996 12.1134C32.4641 13.0779 32.4641 14.6413 31.4996 15.6058L22.1066 24.9999L31.4996 34.3941C32.4641 35.3586 32.4641 36.9221 31.4996 37.8865C31.018 38.3694 30.3857 38.6102 29.7534 38.6102L29.7534 38.6103Z" fill="black"/>
                    </svg>
                    <h3>{t('FormLayerHeader.CTA.Back')}</h3>
                </button>
            </div>
    );
};

export default FormLayerCloseCta;